import {Component} from '@angular/core';

import {NavController, Loading, LoadingController} from 'ionic-angular';
import {CreatePatientPage} from '../create-patient/create-patient'
import {PatientService} from "../../providers/patient-service";
import {PatientPage} from "../patient/patient";
import {FormControl} from "@angular/forms";

@Component({
  selector: 'patients-page',
  templateUrl: 'patients.html'
})
export class PatientsPage {

  loading: Loading;
  patients: any;
  searchTerm: string = "";
  searchControl: FormControl;

  patientPage = PatientPage;
  createPatientPage = CreatePatientPage;
  doctor_id = localStorage.getItem("doctor_id")


  constructor(public navCtrl: NavController,
              private loadingCtrl: LoadingController,
              private patientService: PatientService) {
    this.searchControl = new FormControl();
  }

  ngOnInit() {
    this.patientService.getDoctorPatients(this.doctor_id).subscribe(patients => {
      this.patients = patients
    }, error => {
      alert(error)
    })
  }

  ionViewDidLoad() {

    this.setFilteredItems();
  }

  setFilteredItems() {
    if (this.searchTerm === '') {
      this.resetPatients()
    } else {
      this.patients = this.patientService.filterItems(this.searchTerm, this.patients);
    }


  }

  resetPatients() {
    this.showLoading()
    this.patientService.getDoctorPatients(this.doctor_id).subscribe(patients => {
      this.patients = patients
      setTimeout(() => {
        this.loading.dismiss();
      })
    }, error => {
      alert(error)
    })
  }

  viewVisitPage(patient_id) {
    this.navCtrl.push(this.patientPage, {patient_id: patient_id})
  }

  showLoading() {
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/patients/patients.ts